<template>
  <div>
    <div class="md-layout-item text-left">
      <h5 v-if="label" class="md-toolbar-section-start">{{label | token_replace(nid)}}</h5>

      <span class="md-helper-text">{{ checkbox.help_text | token_replace(nid) }}</span>

      <div v-bind:key="index" v-for="(option, index) in options" class="md-layout md-gutter">
        <div class="md-layout-item md-toolbar-section-start">
          <div :class="messageClass" class="label-top">
            <md-radio
              :class="messageClass"
              @change="updateValue"
              v-model="value"
              :value="option.value"
            >{{option.label}}</md-radio>
          </div>
        </div>
      </div>
      <div v-if="checkbox.other">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-toolbar-section-start">
            <md-radio @change="updateValue" v-model="value" value="other">Other</md-radio>
          </div>
        </div>
      </div>
    </div>
    <div v-if="checkbox.other">
      <md-field v-if="value == 'other'">
        <label>{{ checkbox.other_label | token_replace(nid)}}</label>
        <md-input v-model="other_text" @input="updateValue"></md-input>
      </md-field>
    </div>
    <md-field v-if="!this.valid" :class="messageClass" class="label-top">
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
</template>
<script>
export default {
  name: "FbRadioButtonView",
  props: ["checkbox", "valid", "validate", "nid"],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    }
  },
  data() {
    return {
      label: this.checkbox.label,
      options: this.checkbox.options.map(option => {
        return Object.assign({}, option);
      }),
      value: this.checkbox.value,
      other_text: this.checkbox.other_text
    };
  },
  methods: {
    updateValue() {
      this.$emit("change", {
        value: this.value,
        other_text: this.other_text
      });
    }
  },
  watch: {
    checkbox: function(val) {
      this.label = val.label;
      this.value = val.value;
      this.options = val.options.map(option => {
        return Object.assign({}, option);
      });
    },
    "checkbox.value": function(val) {
      this.value = val;
    }
  }
};
</script>

<style lang="scss">
.md-invalid label {
  color: #ff1744;
}
.md-helper-text {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.label-top {
  &.md-field {
    .md-error {
      bottom: auto;
      top: 0;
    }
    padding: 0;
    margin: 0;
    &::after {
      display: none;
    }
    label {
      top: 0px;
    }
  }
}
</style>
